import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'UIComponents/elements/headings';
import UIToggle from 'UIComponents/input/UIToggle';
import UIList from 'UIComponents/list/UIList';
import UISection from 'UIComponents/section/UISection';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReenrollmentSelect = ({
  readOnly,
  objectTypeId,
  shouldReenroll,
  setShouldReenroll,
  reenrollDescription
}) => {
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "200",
    as: "div",
    children: [/*#__PURE__*/_jsx(H7, {
      children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-enrollment.redesign.review.reenroll_title_cob",
        objectTypeId: objectTypeId
      })
    }), /*#__PURE__*/_jsx(UIToggle, {
      "data-test-id": "reenrollment-toggle",
      readOnly: readOnly,
      checked: shouldReenroll,
      onChange: ({
        target: {
          checked
        }
      }) => {
        setShouldReenroll(checked);
      }
    }), shouldReenroll && /*#__PURE__*/_jsxs(UISection, {
      children: [/*#__PURE__*/_jsx(H7, {
        className: "m-top-5 m-bottom-3",
        children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "automation-ui-enrollment.redesign.review.runWorkflow_cob",
          objectTypeId: objectTypeId
        })
      }), reenrollDescription !== null && reenrollDescription !== void 0 ? reenrollDescription : /*#__PURE__*/_jsx(UIList, {
        styled: true,
        className: "p-left-5",
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.redesign.review.manualReenrollment"
          })
        })
      })]
    })]
  });
};
export default ReenrollmentSelect;